import React, {useState} from 'react';

import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal, Row} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {RotateCircleLoading} from "react-loadingg";
import {resource_strings} from "../../translations/resource_translations";
import dateHelpers from "../../helpers/DateHelper";
import resourceHelper from "../../helpers/ResourceHelper";
import constants from "../../shared/constants";
import ResourceApiService from "../../api/resource-api-service";
import Select from "react-select";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import {func} from "prop-types";
import ClassApiService from "../../api/classes-api-service";
import lsHelpers from "../../helpers/LsHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const options = [
    {value: '1', label: "1"},
    {value: '2', label: "2"},
    {value: '3', label: "3"},
    {value: '4', label: "4"},
]

const CopyClassesControls = (props) => {
    const [visible, setVisible] = useState(true);
    const [weeksCount, setWeeksCount] = useState(options[0]);
    const [completed, setCompleted] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const onDismiss = () => setVisible(false);

    function toggle(formModal) {
        setVisible(!visible);
        props.toggleModal();
    }

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    function copySchedule(e) {
        setIsLoading(true);
        e.preventDefault();
        ClassApiService.copySchedule(parseInt(weeksCount.value), lsHelpers.getWeekScheduleShift())
            .then(res => {
                setIsLoading(false);
                setCompleted('ok');
                props.reloadSchedule()
            })
            .catch((e) => {
                setCompleted(e.message);
                props.handleError(e)
            });
    }

    function handleSelected(selectedOption) {
        setWeeksCount(selectedOption)
    };

    return (
        <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >
            <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {isLoading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <Row className="align-items-center">
                        <div className="col">
                            <h2 className="text-white mb-0">{resourceStrings.copy_classes_expl}</h2>
                        </div>

                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggle("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Form>
                        <div className="pl-lg-12">
                            {!completed &&
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label text-white"
                                    >
                                        {resourceStrings.copy_classes_select}
                                    </label>
                                    <Row>
                                        <Col lg="10">
                                            <Select
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    color: "black",
                                                    transform: 'translateY(-50%)'
                                                }}
                                                className="form-control-alternative text-blue"
                                                placeholder={commonStrings.select}
                                                value={weeksCount}
                                                onChange={handleSelected}
                                                options={options}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            }
                            {completed &&
                            <div style={{margin: 20, display: "flex", justifyContent: "center", textWeight: 600}}>
                                {completed == "ok" ? resourceStrings.classes_were_added : completed}
                            </div>}
                            <Row>
                                <Col lg="12" className="text-right">
                                    <Button
                                        color={"danger"}
                                        type="button"
                                        size="lg"
                                        onClick={e => toggle(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>
                                    {!completed &&
                                    <Button
                                        color={"primary"}
                                        type="button"
                                        size="lg"
                                        onClick={e => copySchedule(e)}
                                    >
                                        {commonStrings.copy}
                                    </Button>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    );
};

export default CopyClassesControls;